<template>
    <div class="ui-content dashboard">
        <div class="page-user approved">
            <v-tabs
                v-model="tab"
                background-color
                class="elevation-2 cust-tab appr-user"
                :centered="centered"
                :grow="grow"
                :vertical="vertical"
                :right="right"
                :prev-icon="prevIcon ? 'mdi-arrow-left-bold-box-outline' : undefined"
                :next-icon="nextIcon ? 'mdi-arrow-right-bold-box-outline' : undefined"
                :icons-and-text="icons"
            >
                <v-tabs-slider></v-tabs-slider>
                <v-tab :href="'#Coordinator'">Coordinator</v-tab>
                <v-tab :href="'#Student'">Student</v-tab>
                <v-tab :href="'#Parent'">Parent</v-tab>
                <v-tab :href="'#Teacher'">Teacher</v-tab>
                <v-tab :href="'#DEO'">D.E.O</v-tab>
                <v-tabs-items :touchless="true" v-model="tab">
                    <v-tab-item :value="'Coordinator'">
                        <v-card class="mx-auto normal-card">
                            <UsersCoor :updateRouteDetails="updateRouteDetails" />
                        </v-card>
                    </v-tab-item>
                    <v-tab-item :value="'Student'">
                        <v-card class="mx-auto normal-card">
                            <UsersStudent :updateRouteDetails="updateRouteDetails" />
                        </v-card>
                    </v-tab-item>
                    <v-tab-item :value="'Parent'">
                        <v-card class="mx-auto normal-card">
                            <UsersParents :updateRouteDetails="updateRouteDetails" />
                        </v-card>
                    </v-tab-item>
                    <v-tab-item :value="'Teacher'">
                        <v-card class="mx-auto normal-card">
                            <UsersTeacher :updateRouteDetails="updateRouteDetails" />
                        </v-card>
                    </v-tab-item>
                    <v-tab-item :value="'DEO'">
                        <v-card class="mx-auto normal-card">
                            <UsersDEO :updateRouteDetails="updateRouteDetails" />
                        </v-card>
                    </v-tab-item>
                </v-tabs-items>
            </v-tabs>
        </div>
    </div>
</template>
<script>
import UsersParents from "@/components/coordinator/users/ApprovedUsers/UsersParents.vue";
import UsersCoor from "@/components/coordinator/users/ApprovedUsers/UsersCoor.vue";
import UsersStudent from "@/components/coordinator/users/ApprovedUsers/UsersStudent.vue";
import UsersTeacher from "@/components/coordinator/users/ApprovedUsers/UsersTeacher.vue";
import UsersDEO from "@/components/coordinator/users/ApprovedUsers/UsersDEO.vue";


import { mapActions, mapState, mapMutations } from "vuex";
export default {
    name: "ApprovedUsers",
    components: {
        UsersParents,
        UsersCoor,
        UsersStudent,
        UsersTeacher,
        UsersDEO
    },
    data() {
        return {
            tab: null,
            icons: false,
            centered: false,
            grow: false,
            vertical: false,
            prevIcon: false,
            nextIcon: false,
            right: false,
            tabs: 3
        };
    },
    mounted() {
        this.addBreadCrumbChilde([
            {
                text: "Student",
                disabled: false
            }
        ]);
        this.checkSessionData();
    },
    methods: {
        ...mapMutations("app", ["addBreadCrumbChilde"]),
        updateRouteDetails(details) {
            let routeName = this.$route.name;            
            let crd = this.getCurrentRouteDetails(routeName);           
            switch (details.type) {
                case 'centerIds':
                    crd.tabDetails[crd.selectedTab].centerIds = details.data.centerIds;                                                            
                    // crd.tabDetails[crd.selectedTab].batchIds = [];                                                            
                    break;            
                case 'batchIds':
                    crd.tabDetails[crd.selectedTab].batchIds = details.data.batchIds;                                                            
                    break;            
                default:
                    break;
            }
            this.setRouteDetails(crd)
        },
        defaultData() {
            let routeName = this.$route.name;
            let crd = this.getCurrentRouteDetails(routeName); 
            if(crd) {
                this.tab = crd.selectedTab ? crd.selectedTab : 'Student';
            }
        },
        checkSessionData() {
            let rp = this.$route; // route params
            let crd = this.getCurrentRouteDetails(rp.name);
            
            if(rp.params.resetPage || !crd.routeName) {
                let subTabDetails = {
                    page: 1, 
                    centerIds: [], 
                    batchIds: [],
                    orderBy: {
                        field: 'name',
                        order: 'ASC'
                    }                 
                }; 
                let tabDetail = {
                    Parent:subTabDetails,
                    Student:subTabDetails,
                    Coordinator:subTabDetails
                };
                let routeDetails = {
                    routeName: rp.name,
                    selectedTab: 'Student',
                    tabDetails: tabDetail,
                    // tabDetailObjs: tabDetail
                }
                this.setRouteDetails(routeDetails);
            }
            this.defaultData();
        },
    },
    watch: {
        tab(val, oldVal) {
            if(oldVal) { // only when tab is changed and not on page load
                let routeName = this.$route.name;
                this.setRouteDetails({routeName, selectedTab: val});
            }
            this.addBreadCrumbChilde([
                {
                    text: val,
                    disabled: false
                }
            ]);
        }
    }
};
</script>